import {
  FETCH_CAREPROVIDERS_FULFILLED,
  FETCH_CAREPROVIDERS_REJECTED,
  FETCH_CAREPROVIDERS_PENDING,
  RESET,
} from "../../actions/application/careProviders";
const initialState = {
  done: false,
  error: false,
  spinner: false
};

export default (state = initialState, action) => {

  switch (action.type) {

    case FETCH_CAREPROVIDERS_PENDING:
      return {
        done: false,
        error: false,
        spinner: true,
      };
    case FETCH_CAREPROVIDERS_FULFILLED:
      return {
        ...state,
        careProviders: action.payload,
        done: true,
        error: false,
        spinner: false
      };
    case FETCH_CAREPROVIDERS_REJECTED:
      return {
        ...state,
        error: action.payload,
        done: false,
        spinner: false
      };
    case RESET:
      return {
        initialState,
        done: false,
        error: false,
      };
    default:
      return state;
  }
};